<template>
  <div id="chargerReport">
    <div class="filter-container">
      <div id="search">
        <!-- <el-input v-model="listQuery.curveNo" style="width: 200px;" class="filter-item" placeholder="DeviceNo" @keyup.enter.native="searchTable" />
        <el-button class="filter-item" type="primary" icon="el-icon-search" @click="searchTable">Search</el-button> -->
        <el-input v-model="listQuery.sn" clearable :placeholder="$t('lease.machineSN')" class="input-with-select deviceNameTable" @clear="searchTable(tableObj.deviceName)">
          <el-button slot="append" icon="el-icon-search" @click="searchTable" />
        </el-input>
      </div>
    </div>

    <el-table v-loading.body="listLoading" :data="list" element-loading-text="Loading" border fit highlight-current-row>
      <el-table-column type="expand">
        <template slot-scope="scope">
          <el-form label-position="left" inline class="demo-table-expand">
            <el-col :xs="12" :sm="12" :lg="8">
              <el-form-item :label="$t('adminView.Track')">
                <span>{{ scope.row.barCode||'--' }}</span>
              </el-form-item>
            </el-col>
            <el-col :xs="12" :sm="12" :lg="8">
              <el-form-item :label="$t('QR.Salesordernumber')">
                <span>{{ scope.row.saleno||'--' }}</span>
              </el-form-item>
            </el-col>
            <el-col :xs="12" :sm="12" :lg="8">
              <el-form-item :label="$t('adminView.PCBVersion1')">
                <span>{{ scope.row.pcbV1||'--' }}</span>
              </el-form-item>
            </el-col>
            <el-col :xs="12" :sm="12" :lg="8">
              <el-form-item :label="$t('adminView.PCBVersion2')">
                <span>{{ scope.row.pcbV2||'--' }}</span>
              </el-form-item>
            </el-col>
            <el-col :xs="12" :sm="12" :lg="8">
              <el-form-item :label="$t('adminView.PCBVersion3')">
                <span>{{ scope.row.pcbV3||'--' }}</span>
              </el-form-item>
            </el-col>
            <el-col :xs="12" :sm="12" :lg="8">
              <el-form-item :label="$t('adminView.PCBVersion4')">
                <span>{{ scope.row.pcbV4||'--' }}</span>
              </el-form-item>
            </el-col>
            <el-col :xs="12" :sm="12" :lg="8">
              <el-form-item :label="$t('adminView.PCBVersion5')">
                <span>{{ scope.row.pcbV5||'--' }}</span>
              </el-form-item>
            </el-col>
            <el-col :xs="12" :sm="12" :lg="8">
              <el-form-item :label="$t('adminView.PCBVersion6')">
                <span>{{ scope.row.pcbV6||'--' }}</span>
              </el-form-item>
            </el-col>
          </el-form>
        </template>
      </el-table-column>
      <el-table-column :label="$t('QR.deviceSN')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.sn }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('adminView.Model2')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.proModule }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('QR.warrantyperiod')" align="center">
        <template slot-scope="scope">
          <span>{{ formatTime(scope.row.warrantyDate,0) }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('liBattery.productionDate')" align="center">
        <template slot-scope="scope">
          <span>{{ formatTime(scope.row.makeDate,0) }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('adminView.OrderDate')" align="center">
        <template slot-scope="scope">
          <span>{{ formatTime(scope.row.orderDate,0) }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('adminView.Created')" align="center">
        <template slot-scope="scope">
          <span>{{ formatTime(scope.row.createTime,0) }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('yhubReport.Operating')" align="center" width="100">
          <template slot-scope="scope">
            
            <!-- 二维码连接 -->
            <el-button title="二维码连接" type="text" icon="el-icon-view" size="small" @click="viewUrl(scope.row)"> </el-button>
          </template>
        </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div style="background-color: white;width: 100%;border-radius: 0 0 10px 10px;">
      <div class="pagination-container">
        <el-pagination
          v-if="pageshow"
          background
          current-page.sync="listQuery.pageInfo.page"
          :page-sizes="listQuery.pageInfo.pageList"
          :page-size="listQuery.pageInfo.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="listQuery.pageInfo.total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { upload, pageBpQrData } from '@/api/QR'
import { pagination } from '@/utils/init_table' // 分页

export default {
  data() {
    return {
      list: null,
      listLoading: true,
      // 分页----start
      listQuery: {
        deviceVersion: null,
        pageInfo: pagination(),
        q: ''
      },
      pageshow: true
      // 分页----end
    }
  },
  created() {
    this.queryList()
  },
  methods: {
    viewUrl (row) {
      open(`http://www.scanmi.net/d/03/?sn=${row.sn}&m=${row.proModule}`)
    },
    queryList() {
      this.listLoading = true
      var param = {
        companyIdList: [],
        sn: this.listQuery.sn,
        pageNum: this.listQuery.pageInfo.pageNum, // 分页--选中某一页
        pageSize: this.listQuery.pageInfo.pageSize // 分页--每一页的列表的行数 10 20 50
      }
      pageBpQrData(param).then(response => {
        this.list = response.resultModel.list
        this.list.forEach(v => {
          // if (v.sn && v.sn.indexOf('PY') == -1)v.sn = 'PY' + v.sn
        })
        this.listQuery.pageInfo.total = response.resultModel.total // 分页

        this.listLoading = false
      })
    },
    searchTable() {
      this.listQuery.pageInfo.pageNum = 1
      this.pageshow = false
      this.queryList()
      this.$nextTick(() => {
        this.pageshow = true
      })
    },
    // 分页----start
    handleSizeChange(val, e) { // 每一页的列表的行数 10 20 50
      this.listQuery.pageInfo.pageSize = val
      this.queryList()
    },
    handleCurrentChange(val, e) { // 选中某一页
      this.listQuery.pageInfo.pageNum = val
      this.queryList()
    },
    // 分页----end
    formatTime(s, i) {
      if (s) {
        s = s.split('T')
        return s[0]
      }
      return s
    }
  }
}
</script>
<style lang="scss">
#chargerReport{
  background: #fff;
  padding: 13px 20px;
  #search .el-input-group {
    width: 40%!important;
    max-width: 300px!important;
    // margin-top: 13px;
  }
}
</style>
